<template>
  <div class="text-xs-center">
    <v-dialog persistent v-model="dialog" width="500">
      <v-card>
        <v-card-text>
          <v-flex>
            <v-text-field
              prepend-icon="event"
              single-line
              readonly
              hide-details
              clearable
              v-model="completionDate"
              :label="$t('order_operations_maker.completion_date')"
              @click="changeDate($event, 'completionDate')"
            ></v-text-field>
          </v-flex>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="!loading" color="primary" flat @click="makeOperations">
            {{ $t("order_operations_maker.confirm") }}
          </v-btn>
          <v-progress-circular
            v-if="loading"
            indeterminate
            color="primary"
          ></v-progress-circular>
          <v-btn color="primary" flat @click="dialog = false">
            {{ $t("order_operations_maker.cancel") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <DatePicker ref="datePicker" @dateSelected="selectDate" />
  </div>
</template>

<script>
import Order from "@/models/Order.js";
import Product from "@/models/Product.js";
import DatePicker from "@/components/DatePicker.vue";
export default {
  components: {
    DatePicker,
  },
  data() {
    return {
      loading: false,
      completionDate: null,
      dialog: false,
      orders: [],
      onKeyUp: (e) => {
        if (e.key === "Escape") {
          this.dialog = false;
        }
        if (e.key === "Enter") {
          this.makeOperations();
        }
      },
    };
  },
  watch: {
    dialog(val) {
      if (val) {
        this.keyUpHandler = this.onKeyUp.bind(this);
        document.addEventListener("keyup", this.keyUpHandler);
      } else {
        document.removeEventListener("keyup", this.keyUpHandler);
      }
    },
  },
  methods: {
    async open(orders) {
      this.orders = orders;
      this.dialog = true;
    },

    async makeOperations() {
      this.loading = true;
      const orderIds = this.orders.map((e) => {
        return e.id;
      });
      const orders = await Order.loadSpecific(orderIds);
      const products = [];
      orders.forEach((order) => {
        order.status = 6;
        order.products.forEach((product) => {
          product.completion_date = this.completionDate;
          products.push(product);
        });
      });
      await Order.updateMany(orders);
      await Product.save(products);
      this.dialog = false;
      this.loading = false;
      this.$emit("saved");
    },

    changeDate(event, key) {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.open(event, key);
      }
    },

    selectDate(date, key) {
      this[key] = date;
    },
  },
};
</script>
